/* eslint-disable camelcase */
import { Box } from '@mui/material'
import { Trans } from 'react-i18next'
import { sprintf } from 'sprintf-js'
import { Port } from '../../types/models'
import { EmNetsumConfig, EmNetsumPort, PortConfigEmNetsum } from '../../types/ports'
import { DeviceControl } from '../DeviceControl'
import { PortControl } from './PortControl'

/**
 * Controller for netsum power meter.
 */
export class NetsumPowerMeterPortControl extends PortControl<EmNetsumPort, EmNetsumConfig> {

  port: EmNetsumPort

  constructor(deviceControl: DeviceControl, port: Port) {
    super(deviceControl, port)
    this.port = port as EmNetsumPort
  }

  getDescription(): string { return this.app.t('Total net power') }

  getTypeName(): string { return this.app.t('PortType-Netsum Power Meter') }

  get group(): string { return this.app.t('PortGroup-Energy Metering') }

  getConfigDefaults(): PortConfigEmNetsum {
    return {
      enabled: false
    }
  }

  configTopRight() : React.ReactNode | undefined {
    const { energy, power } = this.port.values

    return <Box>
      <Trans>Measuring Data</Trans>
      <Box data-cy="box-Power" sx={{ mt: 2 }}><Trans>Power</Trans>: {power === undefined ? <>—</> : `${sprintf('%f', power)} W`}</Box>
      <Box data-cy="box-Energy"><Trans>Energy</Trans>: {energy === undefined ? <>—</> : `${sprintf('%.3f', energy / 3.6e6)} kWh`}</Box>
    </Box>
  }
}
